import { useMutation, useQueryClient } from "react-query";
import { Put } from "../utils/api";
import { useAuth0 } from "@auth0/auth0-react";
import { InventoryTransaction } from "../../types/api/Inventory";

interface UpdateInventoryBody {
  count: number;
  inventory_transaction_type: "add" | "remove";
  product: {
    id: string;
  };
}

export default (orgId: string) => {
  const queryClient = useQueryClient();
  const { getAccessTokenSilently } = useAuth0();
  return useMutation<InventoryTransaction, null, UpdateInventoryBody>(
    async (body: UpdateInventoryBody) =>
      Put(`/api/inventory/transaction`, await getAccessTokenSilently(), body),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([`products_${orgId}`]);
      },
    }
  );
};
